"use strict";
var uncurryThis = require("../internals/function-uncurry-this");
var isCallable = require("../internals/is-callable");
var store = require("../internals/shared-store");
var functionToString = uncurryThis(Function.toString);
if (!isCallable(store.inspectSource)) {
  store.inspectSource = function(it) {
    return functionToString(it);
  };
}
module.exports = store.inspectSource;
